import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ClalLoginStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const useYupLoginLandingClalValidationSchema = () => {
  const { t } = useTranslation();
  const yupLoginLandingClalValidationSchema = useMemo(() => {
    return {
      [ClalLoginStepFormFieldsEnum.Email]: yupLanding
        .string()
        .required()
        .email()
        .test(
          "clal-email",
          t("landing.validation.emailDomain", {
            email: "clal-ins.co.il",
          }),
          value => {
            return (
              value?.endsWith("@clal-ins.co.il") ||
              value?.endsWith("@goryde.com") ||
              false
            );
          },
        ),
      [ClalLoginStepFormFieldsEnum.AcceptTerms]: yupLanding
        .boolean()
        .required(),
    };
  }, [t]);
  return { yupLoginLandingClalValidationSchema };
};
